import  { useContext, useEffect, useRef, useState } from "react";
import { BookMark, Colour, Dbookmark, FontType, Bplay, Hindit, IskconContent, BookMarkNext, AddedSongs, DownloadedSongs, CurrentAudioUrl, CurrentAudioRef, BookContent, BhagavatamCotent, BsubSpos, Fsing, UserAudios, SPContent, Medias, MediaFile } from "../global";
import { IonItem, IonReorderGroup, IonButton, IonLabel, IonToolbar, IonButtons, IonCheckbox, IonReorder, IonPage, IonHeader, IonContent, isPlatform, IonSpinner} from "@ionic/react";
import { ArrowBackSharp, TocSharp, IndeterminateCheckBoxOutlined, PlaylistPlay, ShuffleSharp, PeopleAltSharp, CloudDownloadSharp, MoreVertSharp, Sync } from "@mui/icons-material";
import { useHistory, useParams, useLocation, useRouteMatch } from "react-router-dom";
import { NativeAudio } from '@capacitor-community/native-audio'
import { File } from '@awesome-cordova-plugins/file';
import { Filesystem } from "@capacitor/filesystem";
import { MediaSession } from "@jofr/capacitor-media-session"


function Bsub() {
  let {  url } = useRouteMatch();
 const [bookMark, dispatch] = useContext(BookMark); 
 const [hindit, ] = useContext(Hindit);
 const [iskcon, ] = useContext(IskconContent);
 const [addedSongs, setAddedSongs] = useContext(AddedSongs)
 const [bfolder, setBfolder] = useState([])
 const[btitle, setBtitle] = useState("")
 const [downloadedSongs, setDownloadedSongs] = useContext(DownloadedSongs)
 const [, setCurrentAudioUrl] = useContext(CurrentAudioUrl);
 const content = useContext(BookContent);
 const [content2, ] = useContext(BhagavatamCotent)
 const [piskcon, ] = useContext(SPContent)
 const contentRef = useRef();
 let location = useLocation();
 const [spos, setSpos] = useContext(BsubSpos);
 const [, setFsing] = useContext(Fsing)
 const [userAudios, setUserAudios] = useContext(UserAudios)
 const [, setPpb] = useContext(Medias)
 const [isSyncing, setIsSyncing] = useState(false)
 let locy = 0;

 let { ind } = useParams();
 let nind = Number(ind);

 let btype;

 if(isNaN(ind)) {
  btype="singer"
 }else{
  btype = "bookmark"
 }


 function isAudioExisit(path){
  if(path.replace("iskcon","home").indexOf("/home") !== -1){
    return 1
  }
  else if(path.indexOf("/books") !== -1) {
    let indexs = path.split("/").slice(2)
    let booki
    for (let i=0; i<content.length; i++) {
      if (content[i].name === indexs[0]){
        booki = i
        break
      } 
    }
    if(indexs.length === 3){
      if (content[booki]["chap"][indexs[1]]["song"][indexs[2]].vname) return 1
    }
    else if(indexs.length === 2) {
      if (content[booki]["song"][indexs[1]].vname) return 1
    }
  }
  else if(path.indexOf("/sb") !== -1) {
    let indexs = path.split("/").slice(2)[0].split("_")
    if(content2["chap"][indexs[0]]["song"][indexs[1]]["link"]) return 1
  }
  else if(path.indexOf("/sp") !== -1) {
    return 1
  }
  return -1
 }

 function isCustomAudioExist(songName){
  if(!addedSongs[songName]) return 0
  for (let i=0; i< addedSongs[songName].length; i++) {
    if(addedSongs[songName][i].type !== "youtube") return 1
  }
  return 0
 }

 function setSongSinger(songIndex) {
  if(bfolder[songIndex].index || bfolder[songIndex].index === 0) {
    if(bfolder[songIndex].type === "default"){
        setFsing((prev) => {
          let dum = { ...prev };
          dum[bfolder[songIndex].name] = bfolder[songIndex].index;
          return dum;
        });
        setUserAudios((prev)=>{
          let dum = {...prev}
          dum[bfolder[songIndex].name] = null
          return dum
        })
    }
    if(bfolder[songIndex].type === "user"){
        setUserAudios((prev)=>{
          let dum = {...prev}
          dum[bfolder[songIndex].name] = {"id": bfolder[songIndex].index, "type": addedSongs[bfolder[songIndex].name][bfolder[songIndex].index].type, "linkname": addedSongs[bfolder[songIndex].name][bfolder[songIndex].index].singer, "hlinkname":addedSongs[bfolder[songIndex].name][bfolder[songIndex].index].singer,  "linkaddress": addedSongs[bfolder[songIndex].name][bfolder[songIndex].index].path}
          return dum
        })
    }
    if(bfolder[songIndex].type === "downloaded") {
      let songList = []
      let songName = bfolder[songIndex].name
      let path = bfolder[songIndex].path
      if(path.replace("iskcon","home").indexOf("/home") !== -1 || path.indexOf("/books") !== -1){
        for (let song of iskcon.songs){
          if (song.name === songName) {
            songList = song.link
            break
          }
        }
      }
      else if(path.indexOf("/sb") !== -1) {
        for (const [, chap] of content2.chap.entries()) {
          for (const [, song] of chap.song.entries()) {
            if (song.name.slice(3) === bfolder[songIndex].name) {
              songList = (song.link ?? [])
              break
            }
          }
        }
      }
      else if(path.indexOf("/sp") !== -1) {
        for (let song of piskcon.songs){
          if (song.name === bfolder[songIndex].name) {
            songList = song.link
            break
          }
        }
      }
      for (let i=0; i<songList.length; i++) {
        let singerKey = songList[i].linkname
        if(bfolder[songIndex].index===singerKey) {
            setFsing((prev) => {
              let dum = { ...prev };
              dum[bfolder[songIndex].name] = i;
              return dum;
             });
            setUserAudios((prev)=>{
              let dum = {...prev}
              dum[bfolder[songIndex].name] = null
              return dum
            })
        }
      }
      if(addedSongs[bfolder[songIndex].name]) {
      for (let i=0; i<addedSongs[bfolder[songIndex].name].length; i++) {  
        let singerKey = (addedSongs[bfolder[songIndex].name][i]).singer
        if(bfolder[songIndex].index===singerKey) {
          setUserAudios((prev)=>{
            let dum = {...prev}
            dum[bfolder[songIndex].name] = {"id": i, "type": addedSongs[bfolder[songIndex].name][i].type, "linkname": addedSongs[bfolder[songIndex].name][i].singer, "hlinkname":addedSongs[bfolder[songIndex].name][i].singer,  "linkaddress": addedSongs[bfolder[songIndex].name][i].path}
            return dum
          })
        }
      }
    }
    }
  }
 }

 async function isDownloaded(filePath, songName, singerName, songPath, dum) {
  try{
    await NativeAudio.preload({
      assetId: songName + singerName,
      assetPath: filePath,
      audioChannelNum: 1,
      isUrl: true
    })
    await NativeAudio.unload({
      assetId: songName + singerName,
    })
    if(!dum[songName]) dum[songName] = {}
    dum[songName][singerName] = {link: songPath, filepath: filePath}
  } catch(err) {
  }
 }

 async function syncDownloaded() {
  if(!isSyncing){
  setIsSyncing(true)
  let downloadedSongsList = {}
  const promises = [];
  for (let song of iskcon.songs){
    for(let i=0; i< song.link.length; i++) {
      let singer = song.link[i]
      let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + song.name.replace(/\s+/g, '_') + "-" + singer.linkname.replace(/\s+/g, '_') + ".mp3";
      let songPath = `/home/songs/${song.name}_${song.book ?? ""}`
      promises.push(isDownloaded(filePath, song.name, singer.linkname, songPath, downloadedSongsList))
    }
  }
  for (let j in piskcon.songs) {
    let singer = "Srila Prabhupada"
    let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + piskcon.songs[j].name.replace(/\s+/g, '_') + "-" + singer.replace(/\s+/g, '_') + ".mp3";
    let songPath = `/sp/${j}`
    promises.push(isDownloaded(filePath, piskcon.songs[j].name, singer, songPath, downloadedSongsList))
  }
  for (const [i, chap] of content2.chap.entries()) {
    for (const [j, song] of chap.song.entries()) {
      for(let singer of (song.link ?? [])) {
        let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + song.name.replace(/\s+/g, '_') + "-" + singer.linkname.replace(/\s+/g, '_') + ".mp3";
        let songPath = `/sb/${i}_${j}`
        promises.push(isDownloaded(filePath, song.name, singer.linkname, songPath, downloadedSongsList))
      }
    }
  }
  for (let songName of Object.keys(addedSongs)) {
    for (let i=0; i< addedSongs[songName].length; i++) {
      let singer = addedSongs[songName][i]
      let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + (singer.type === "file" ? singer.path : songName.replace(/\s+/g, '_') + "-" + singer.singer.replace(/\s+/g, '_') + ".mp3");
      if(singer.type === "mp3" || singer.type === "file") promises.push(isDownloaded(filePath, songName, singer.singer, singer.link, downloadedSongsList))
    }
  }
  await Promise.all(promises);
  setDownloadedSongs(downloadedSongsList)
  setIsSyncing(false)
  }
 }

 useEffect(()=>{
  let bfolderList=[]
  let englishToHindi = {}
  if(isNaN(ind)) {
    if(ind==="addedsongs"){
      let songsMap = []
      for (let songName of Object.keys(addedSongs)) {
        for (let i=0; i< addedSongs[songName].length; i++) {
          let singer = addedSongs[songName][i]
          songsMap.push({"name": songName, "path": singer.link, "singer": singer.singer, "youtube": singer.type==="youtube" ? true : false, "type": "user", "index": i })
        }
      }
      setBtitle("Added Songs")
      bfolderList = [...songsMap]

    }
    else if(ind==="downloadedsongs") {

      let songsMap = []
      let keysList = Object.keys(downloadedSongs).sort()
      for (let songName of keysList) { 
        for (let i in downloadedSongs[songName]) {
          let singer = downloadedSongs[songName][i]
          songsMap.push({"name": songName, "path": singer.link, "singer": i, "index": i, "type": "downloaded" })
        }
      }
      setBtitle("Downloaded Songs")
      bfolderList = [...songsMap]

    }
    else{
    let singersMap = {}
    for (let song of iskcon.songs){
      for(let i=0; i< song.link.length; i++) {
        let singer = song.link[i]
        let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
        if(singerName === "Srila Prabhupada") singerName = "HDG Srila Prabhupada"
        if(!singersMap[singerName]) singersMap[singerName]=[]
        singersMap[singerName].push({"name": song.name, "path": "/home/songs/"+song.name+"_"+(song.book ?? ""), "type": "default", "index": i})
        let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
        englishToHindi[singerName] = hsingerName
      }
    }
    for (const [i, chap] of content2.chap.entries()) {
      for (const [j, song] of chap.song.entries()) {
        for(let singer of (song.link ?? [])) {
          let singerName = singer.linkname.slice(0, (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) === -1 ? singer.linkname.length : (singer.linkname.indexOf(" (") !== -1 ? singer.linkname.indexOf(" (") : singer.linkname.indexOf("(")) )
          if(singerName === "Srila Prabhupada") singerName = "HDG Srila Prabhupada"
          if(!singersMap[singerName]) singersMap[singerName]=[]
          singersMap[singerName].push({"name": song.name.slice(3), "path": `/sb/${i}_${j}` })
          let hsingerName = singer.hlinkname.slice(0, (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")) === -1 ?  singer.hlinkname.length : (singer.hlinkname.indexOf(" (") !== -1 ? singer.hlinkname.indexOf(" (") : singer.hlinkname.indexOf("(")))
          englishToHindi[singerName] = hsingerName
        }
      }
    }
  
    for (let songName of Object.keys(addedSongs)) {
      for (let i=0; i< addedSongs[songName].length; i++) {
        let singer = addedSongs[songName][i]
        let singerName = singer.singer.slice(0, (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) === -1 ? singer.singer.length : (singer.singer.indexOf(" (") !== -1 ? singer.singer.indexOf(" (") : singer.singer.indexOf("(")) )
        if(!singersMap[singerName]) singersMap[singerName] = []
        singersMap[singerName].push({"name": songName, "path": singer.link, "youtube": singer.type==="youtube" ? true : false, "type": "user", "index": i })
      }
    }
    setBtitle(hindit ? (englishToHindi[ind] ?? ind) : ind)
    bfolderList = singersMap[ind]
  }
  bfolderList.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    // If names are equal, sort by singer
    if (a.singer && b.singer) {
      if (a.singer < b.singer) return -1;
      if (a.singer > b.singer) return 1;
    }
    // If either singer is missing, or both are same, maintain the order
    return 0;
  });
  }else{
    setBtitle(bookMark[nind].name)
    bfolderList = bookMark[nind].songs
  }
  if (hindit) {
    for (let ele of bfolderList){
      if(ele.singer) ele.hsinger = englishToHindi[ele.singer]
      for (let j in iskcon.songs) {
        if (iskcon.songs[j].name === ele.name) {
          ele.hname = iskcon.songs[j].hindi;
          break;
        }
      }
      for (let j in piskcon.songs) {
        if (piskcon.songs[j].name === ele.name) {
          ele.hname = piskcon.songs[j].hindi;
          break;
        }
      }
    }
  }
  setBfolder(bfolderList)
 },[downloadedSongs, addedSongs, (bookMark[nind] ?? {}).songs])

 

 
 

 let history = useHistory();

 let [dbookmark, setDbookmark] = useContext(Dbookmark);
 const [font, ] = useContext(FontType);
 const [bplay, setBplay] = useContext(Bplay);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";

 const [select, setSelect] = useState(false);

 let [reo, setReo] = useState(true);
 let [clr, ] = useContext(Colour);
 let color3,color4,colori,colorh;
 if(clr === "1") {
  color3 = "white"
  colori = ""
  colorh = "primary"
  color4 = "black"
 }
 if(clr === "2") {
  color3 = "dark"
  colori = "secondary"
  colorh = "warning"
  color4 = "black"
 }
 if(clr === "3") {
  color3 = "dark"
  colori = "secondary"
  colorh = "success"
  color4 = "black"
 }
 if(clr === "4") {
  color3 = "dark"
  colori = "secondary"
  colorh = "tertiary"
  color4 = "black"
 }
 if(clr === "5") {
  color3 = "light"
  colori = "dark"
  colorh = "warning"
  color4 = "white"
 }
 if(clr === "6") {
  color3 = "light"
  colori = "dark"
  colorh = "tertiary"
  color4 = "white"
 }



 const [bookMarkNext, setBookMarkNext] = useContext(BookMarkNext);
 const [playSongs, setPlaySongs] = useState(false);
 const currentAudioRef = useContext(CurrentAudioRef);
 const [mediaFile,] = useContext(MediaFile)
 useEffect(() => {
  if (location.pathname === url && contentRef.current) {
      contentRef.current.scrollToPoint(0,spos); 
  }
}, [location, contentRef.current]);

 useEffect(() => {
  if(bplay.fold){
    MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
    if(mediaFile){
    mediaFile.stop()
    if(isPlatform("android") && !isPlatform("mobileweb")) mediaFile.release()
    }
    if(currentAudioRef.current) currentAudioRef.current.pause();
    setCurrentAudioUrl(null)
    setPpb(false)
  }
  },[])

 useEffect(() => {
  if (bplay.fold) {
   let i;
   if(bookMarkNext === "right"){
    if (bplay.song === bfolder.length - 1) i = 0;
    else i = bplay.song + 1;
   }else if(bookMarkNext === "left"){
    if (bplay.song === 0) i = bfolder.length - 1;
    else i = bplay.song - 1;
   }else{
    if(bfolder.length === 1) i=0;
    else{
      i=bplay.song;
      while(i === bplay.song){
        i = Math.floor((Math.random() * bfolder.length));
      }
    }
   }

   while (i < bfolder.length) {
   
    if ((isAudioExisit(bfolder[i].path) !== -1 || isCustomAudioExist(bfolder[i].name)) && (!bfolder[i].youtube)) {
     if(btype === "bookmark") setBplay({ fold: nind + 1, song: i });
     else{
      setBplay({ fold: ind, song: i });
      setSongSinger(i)
     }
     history.push(bfolder[i].path.replace("iskcon","home"));
     break;
    }

    i++;
   }
  }

  dispatch({ type: "reorder", array: dbookmark });
  setDbookmark([]);
 }, [bfolder]);

 useEffect(()=>{
  let i=0;
  let isPlay = false;
  while (i < bfolder.length) {
    if((isAudioExisit(bfolder[i].path) !== -1 || isCustomAudioExist(bfolder[i].name)) && (!bfolder[i].youtube)){
      isPlay = true
      break;
    }
    i++;
  }
  setPlaySongs(isPlay)
 },[bfolder])

 function doReorder(e) {
  let dplay = [...dbookmark];
  dplay.push({ index: nind, from: e.detail.from, to: e.detail.to });
  setDbookmark(dplay);
  e.detail.complete();
 }

 async function deleteUserAudios() {
  if(ind==="addedsongs"){
    let dbfolder = [...bfolder]
    let daddedSongs = {...addedSongs}
    let duserAudios = {...userAudios}
    let ddownloadedSongs = {...downloadedSongs}
    for(let i=0; i<bfolder.length; i++){
        let ele = bfolder[i]
        if(ele.isChecked) {
          dbfolder.splice(i,1)
          duserAudios[ele.name] = null
          for(let j=0; j<daddedSongs[ele.name].length; j++){
            if(j!==ele.index) {
              let jlink = daddedSongs[ele.name][j]
              duserAudios[ele.name] = {"id": j, "type": jlink.type, "linkname": jlink.singer, "hlinkname":jlink.singer,  "linkaddress": jlink.path}
            }
          }
          daddedSongs[ele.name].splice(ele.index,1);
          if(daddedSongs[ele.name].length === 0) delete daddedSongs[ele.name]
          try{ 
            if(ddownloadedSongs[ele.name] && ddownloadedSongs[ele.name][ele.singer]){
              await Filesystem.deleteFile({
                path: ddownloadedSongs[ele.name][ele.singer]["filepath"]
              })
              delete ddownloadedSongs[ele.name][ele.singer]
            } 
            if(!ddownloadedSongs[ele.name]) delete ddownloadedSongs[ele.name]
          }catch(err){
            console.error(err)
          }
        }
     };
     setAddedSongs(daddedSongs)
     setUserAudios(duserAudios)
     setDownloadedSongs(ddownloadedSongs)
   }
   else if(ind==="downloadedsongs"){
    let ddownloadedSongs = {...downloadedSongs}
    for(let i=0; i<bfolder.length; i++){
      let ele = bfolder[i]
      if(ele.isChecked) {
        try{
          if(ddownloadedSongs[ele.name] && ddownloadedSongs[ele.name][ele.singer]){
            await Filesystem.deleteFile({
              path: ddownloadedSongs[ele.name][ele.singer]["filepath"]
            })
            delete ddownloadedSongs[ele.name][ele.singer]
          } 
          if(!ddownloadedSongs[ele.name]) delete ddownloadedSongs[ele.name]
        }catch(err){
          console.error(err)
        }
      }
    }
    setDownloadedSongs(ddownloadedSongs)
   }
 }



 return (
  <IonPage>
    <IonHeader>
  <IonToolbar color={colorh}>
    <IonButtons slot="start" onClick={() => history.push("/lists")}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonButtons slot="start">
     <IonLabel style={{ fontFamily: `${fon}` }}>{btitle ?? "Default"} </IonLabel>
    </IonButtons>

    {!select && btype==="bookmark" ? (
     <IonButtons slot="end" onClick={() => setReo(!reo)}>
      <IonButton>
       <TocSharp />
      </IonButton>
     </IonButtons>
    ) : null}

    {!select && (btype==="bookmark" || ind==="addedsongs" || ind==="downloadedsongs") ? (
     <IonButtons
      onClick={() => {
       setSelect(true);
      }}
      slot="end"
     >
      <IonButton>
       <IndeterminateCheckBoxOutlined />
      </IonButton>
     </IonButtons>
    ) : (
     <p></p>
    )}
    {!select && ind==="downloadedsongs" ? <IonButtons slot="end" onClick={syncDownloaded}>
      <IonButton>
        {isSyncing ? <IonSpinner style={{ fontSize: 30, marginRight:"5px" }} name="crescent"></IonSpinner> : <Sync style={{ fontSize: 30, marginRight:"5px" }} />}
      </IonButton>
    </IonButtons> : null}
    {select ? (
      <>
      <IonButtons
      style={{ margin: "0 8px" }}
      slot="end"
      onClick={async() => {
       if(ind === "addedsongs" || ind === "downloadedsongs") await deleteUserAudios()
       else if (btype==="bookmark") dispatch({ type: "delsong", index: nind });
       setSelect(false);
      }}
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>Remove</IonLabel>
     </IonButtons>
     <IonButtons
     style={{ margin: "0 8px" }}
      onClick={() => {
       bfolder.forEach((ele) => {
        ele.isChecked = false;
       });
       setSelect(false);
      }}
      slot="end"
     >
      <IonLabel style={{ fontFamily: `${fon}` }}>Close</IonLabel>
     </IonButtons>
     </>
    ) : (
     <p></p>
    )}
   </IonToolbar>
   </IonHeader>
        <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori} >
   {bfolder.length > 0 ? <IonReorderGroup disabled={reo} onIonItemReorder={doReorder}>
    {bfolder.map((ele, i) => {
     return (
      <IonItem key={i} button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
        if (!select) {
          if(btype === "bookmark") setBplay({ fold: 0, song: 0 });
          else{
            setBplay({ fold: 0, song: 0 });
            setSongSinger(i)
          } 
         history.push(ele.path.replace("iskcon","home"));
        }
       }}
      >
       
       
       <IonReorder slot="end" />
       {select ? (
        <IonCheckbox
        style={{ fontFamily: `${fon}` }}
         checked={ele.isChecked}
         onIonChange={(e) => {
          ele.isChecked = e.detail.checked;
         }}
        >{ele.singer ? <>
          {hindit && ele.hname ? ele.hname : ele.name}
          <br />
          {hindit && ele.hsinger ? ele.hsinger : ele.singer}
          </> : (hindit && ele.hname ? ele.hname : ele.name)} </IonCheckbox>
       ) : (
        <>
        {ele.singer ? <IonLabel style={{ fontFamily: `${fon}` }}>
        <h2>{hindit && ele.hname ? ele.hname : ele.name}</h2>
        <p>{hindit && ele.hsinger ? ele.hsinger : ele.singer}</p>
         </IonLabel> : 
         <IonLabel style={{ fontFamily: `${fon}` }}>{hindit && ele.hname ? ele.hname : ele.name} </IonLabel>}
         {(isAudioExisit(ele.path) !== -1 || isCustomAudioExist(bfolder[i].name)) && (!bfolder[i].youtube) ? (
          <IonButtons
           slot="end"
          >
           <IonButton onClick={(e) => {
            setBookMarkNext("shuffle")
            if(btype === "bookmark") setBplay({ fold: nind + 1, song: i });
            else{
              setBplay({ fold: ind, song: i})
              setSongSinger(i)
            }
            history.push(ele.path.replace("iskcon","home"));
            e.stopPropagation();
           }} color={color3}>
            <ShuffleSharp style={{ fontSize: "23px" }} />
           </IonButton>
           <IonButton onClick={(e) => {
            setBookMarkNext("right")
            if(btype === "bookmark") setBplay({ fold: nind + 1, song: i });
            else{
              setBplay({ fold: ind, song: i})
              setSongSinger(i)
            }
            history.push(ele.path.replace("iskcon","home"));
            e.stopPropagation();
           }} color={color3}>
            <PlaylistPlay style={{ fontSize: "30px" }} />
           </IonButton>
          </IonButtons>
         ) : null}
        </>
       )}
      </IonItem>
     );
    })}
   </IonReorderGroup> :  (
   <>
       {ind==="addedsongs" && !Object.keys(addedSongs).length ? <>{!hindit ?
        <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
          You can add audios for a song by clicking <MoreVertSharp /> Icon on the heading toolbar of that song or by clicking <PeopleAltSharp /> Icon situated on the left of music controls of that song
        </p> : <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
        आप गाने के हेडिंग टूलबार पर <MoreVertSharp /> आइकन पर क्लिक करके उस गाने के लिए ऑडियो जोड़ सकते हैं या उस गाने के संगीत नियंत्रणों के बाएं ओर स्थित <PeopleAltSharp /> आइकन पर क्लिक करके।
        </p>}</> : null}
        {ind==="downloadedsongs" && !Object.keys(downloadedSongs).length ? <>{!hindit ?
        <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
          You can download a song for offline listening by clicking <CloudDownloadSharp /> Icon situated on the right of music controls of that song
        </p> : <p style={{ textAlign: "center", color: `${color4}`, fontFamily: `${fon}`, margin: "10px" }}>
        आप गाने के संगीत नियंत्रणों के दाएं में स्थित <CloudDownloadSharp /> आइकन पर क्लिक करके उस गाने को ऑफ़लाइन सुनने के लिए डाउनलोड कर सकते हैं।
        </p>}</> : null}
       </>
   )}

   {playSongs ? <>
   <div style={{ height: "40px" }}></div>
    <div style={{ textAlign: "center" }}>
     <IonButton
      onClick={(e) => {
        let i = Math.floor((Math.random() * bfolder.length));
        while (i < bfolder.length) {
          if((isAudioExisit(bfolder[i].path) !== -1 || isCustomAudioExist(bfolder[i].name)) && (!bfolder[i].youtube)) break;
          i = Math.floor((Math.random() * bfolder.length));
         }
        setBookMarkNext("shuffle"); 
        if(btype === "bookmark") setBplay({ fold: nind + 1, song: i });
        else{
          setBplay({ fold: ind, song: i})
          setSongSinger(i)
        }
        history.push(bfolder[i].path.replace("iskcon","home"));
        e.stopPropagation();
      }}
      shape="round"
      color={colorh}
      style={{ width: "250px" }}
     >
      {hindit ? "गीत शफल चलाएं" :" Shuffle Play Songs"}
     </IonButton>
     <div style={{ height: "20px" }}></div>
    </div>
    <div style={{ textAlign: "center" }}>
     <IonButton
      onClick={(e) => {
        let i=0;
        while (i < bfolder.length) {
          if((isAudioExisit(bfolder[i].path) !== -1 || isCustomAudioExist(bfolder[i].name)) && (!bfolder[i].youtube)) break;
          i++;
         }
        setBookMarkNext("right");
        if(btype === "bookmark") setBplay({ fold: nind + 1, song: i });
        else{
          setBplay({ fold: ind, song: i})
          setSongSinger(i)
        }
        history.push(bfolder[i].path.replace("iskcon","home"));
        e.stopPropagation();
      }}
      shape="round"
      color={colorh}
      style={{ width: "250px" }}
     >
      {hindit ? "गीत दोहराएँ चलाएं" : "Repeat Play Songs"}
     </IonButton>
     <div style={{ height: "20px" }}></div>
    </div>
    </> : null}
   </IonContent>
    </IonPage>
 );
}

export default Bsub;
